export const number = (value) => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  return onlyNums;
};

export const float = (value) => {
  if (!value) {
    return value;
  }

  let onlyNumsDots = value.replace(/[^0-9$.]/g, '');
  const dotIndex = onlyNumsDots.indexOf('.');
  const lastDotIndex = onlyNumsDots.lastIndexOf('.');
  if (dotIndex !== lastDotIndex) {
    onlyNumsDots = onlyNumsDots.substring(0, lastDotIndex)
      + onlyNumsDots.substring(lastDotIndex + 1);
  } else if (dotIndex !== -1) {
    onlyNumsDots = onlyNumsDots.substring(0, dotIndex + 3);
  }

  if (onlyNumsDots.length > 0) {
    return onlyNumsDots;
  }

  return '';
};

export const positiveNumber = (value) => {
  if (!value) {
    return value;
  }

  const onlyNumsStart = value.slice(0, 1).replace(/[^1-9]/g, '');
  const onlyNumsEnd = value.slice(1).replace(/[^\d]/g, '');

  return `${onlyNumsStart}${onlyNumsEnd}`;
};

export const positiveNumberWithZero = (value) => {
  if (!value) {
    return value;
  }

  const onlyNumsStart = value.slice(0, 1).replace(/[^0-9]/g, '');
  const onlyNumsEnd = value.slice(1).replace(/[^\d]/g, '');

  return `${onlyNumsStart}${onlyNumsEnd}`;
};

export const socialSecurityNumber = (value) => {
  if (!value) {
    return value;
  }
  const allowedChars = value.replace(/[\D]/g, '');
  if (allowedChars.length <= 3) {
    return allowedChars;
  }
  if (allowedChars.length <= 5) {
    return `${allowedChars.slice(0, 3)}-${allowedChars.slice(3)}`;
  }
  return `${allowedChars.slice(0, 3)}-${allowedChars.slice(3, 5)}-${allowedChars.slice(5, 9)}`;
};

export const profitPercent = (value, previousValue) => {
  const previousValueString = previousValue ? previousValue.toString() : '';
  let precentValue;
  if (previousValueString.replace('%', '') === value && previousValueString.substring(previousValueString.length - 1) === '%') {
    precentValue = value.toString().substring(0, previousValueString.length - 2);
  } else {
    precentValue = value.replace('%', '');
  }
  if (!precentValue) {
    return precentValue;
  }
  if (precentValue[0] === '-') {
    const splitPercent = precentValue.replace(/[^\d.]/g, '').split('.');
    if (splitPercent[1]) {
      return `-${splitPercent[0].slice(0, 2)}.${splitPercent[1].slice(0, 2)}%`;
    } else {
      return precentValue[precentValue.length - 1] === '.' ? `-${splitPercent[0].slice(0, 2)}.` : `-${splitPercent[0].slice(0, 2)}`;
    }
  } else {
    const splitPercent = precentValue.replace(/[^\d.]/g, '').split('.');
    if (splitPercent[1]) {
      return `${splitPercent[0].slice(0, 2)}.${splitPercent[1].slice(0, 2)}%`;
    } else {
      return precentValue[precentValue.length - 1] === '.' ? `${splitPercent[0].slice(0, 2)}.` : `${splitPercent[0].slice(0, 2)}%`;
    }
  }
};

export const date = (value) => {
  if (!value) {
    return value;
  }
  const splitDate = value.replace(/[^\d/]/g, '').split('/');
  let allowedMonth = splitDate[0].slice(0, 2);
  let allowedDay = splitDate[1] !== undefined
    ? splitDate[1].slice(0, 2)
    : null;
  let allowedYear = splitDate[2] !== undefined
    ? splitDate[2].slice(0, 4)
    : null;
  if (!allowedDay && splitDate[0].length > 2) {
    allowedDay = splitDate[0].slice(2, 4);
  }
  if (!allowedYear && splitDate[1] && splitDate[1].length > 2) {
    allowedYear = splitDate[1].slice(2, 6);
  }

  allowedMonth = [...allowedMonth].map((char, index, arr) => {
    switch (index) {
      case 0:
        if (arr[1] && allowedDay && allowedDay.length > 0) {
          return char.replace(/[^01]/g, '');
        }
        return char;
      case 1:
        if (arr[0] === '1') {
          const allowedChar = char.replace(/[^012]/g, '');
          if (allowedChar.length === 0 && (!allowedDay || allowedDay.length === 0)) {
            allowedDay = char;
          }
          return allowedChar;
        } else if (arr[0] === '0') {
          return char;
        }
        if (!allowedDay || allowedDay.length === 0) {
          allowedDay = char;
          return '';
        }
        return char;
      default:
        return '';
    }
  }).join('');

  if (allowedDay) {
    allowedDay = [...allowedDay].map((char, index, arr) => {
      switch (index) {
        case 0:
          if (arr[1] && allowedYear && allowedYear.length > 0) {
            return char.replace(/[^0123]/g, '');
          }
          return char;
        case 1:
          if (arr[0] === '3') {
            return char.replace(/[^01]/g, '');
          } else if (['2', '1', '0'].indexOf(arr[0]) !== -1) {
            return char;
          }
          if (!allowedYear || allowedYear.length === 0) {
            allowedYear = char;
          }
          return '';
        default:
          return '';
      }
    }).join('');
  }

  if (allowedYear !== null && allowedDay !== null) {
    return `${allowedMonth}/${allowedDay}/${allowedYear.slice(0, 4)}`;
  }
  if (allowedDay !== null) {
    return `${allowedMonth}/${allowedDay}`;
  }
  return allowedMonth;
};

export const phone = (value) => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.length === 0) {
    return '';
  }
  if (onlyNums.length <= 3) {
    return `(${onlyNums}`;
  }
  if (onlyNums.length <= 6) {
    return `+1 (${onlyNums.slice(0, 3)}) ${onlyNums.slice(3)}`;
  }
  return `+1 (${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(
    6,
    10,
  )}`;
};

export const zip = (value) => {
  if (!value) {
    return value;
  }
  const allowedChars = value.replace(/[\D]/g, '');

  return allowedChars.slice(0, 5);
};

export const price = (value) => {
  if (!value) {
    return value;
  }

  let allowedChars = value.replace('$', '').replace(/[^0-9.]/g, '');
  const dotIndex = allowedChars.indexOf('.');
  const lastDotIndex = allowedChars.lastIndexOf('.');
  let digits = '';
  if (dotIndex !== lastDotIndex) {
    allowedChars = allowedChars.substring(0, lastDotIndex)
      + allowedChars.substring(lastDotIndex + 1);
  }

  if (dotIndex !== -1) {
    allowedChars = allowedChars.substring(0, dotIndex + 3);
    digits = allowedChars.substring(dotIndex, allowedChars.length);
    allowedChars = allowedChars.substring(0, dotIndex);
    if (allowedChars.length === 0 && dotIndex === 0) {
      allowedChars = '0';
    }
  }

  allowedChars = allowedChars.replace(/^0+/g, '0');

  if (allowedChars.length > 0) {
    const re = '\\d(?=(\\d{3})+$)';
    return `$${allowedChars.replace(new RegExp(re, 'g'), '$&,')}${digits}`;
  }

  return '';
};

export const negativePrice = (value) => {
  if (!value) {
    return value;
  }

  let allowedChars = value.replace('$', '').replace('-', '').replace(/[^0-9.]/g, '');
  const dotIndex = allowedChars.indexOf('.');
  const lastDotIndex = allowedChars.lastIndexOf('.');
  let digits = '';
  if (dotIndex !== lastDotIndex) {
    allowedChars = allowedChars.substring(0, lastDotIndex)
      + allowedChars.substring(lastDotIndex + 1);
  }

  if (dotIndex !== -1) {
    allowedChars = allowedChars.substring(0, dotIndex + 3);
    digits = allowedChars.substring(dotIndex, allowedChars.length);
    allowedChars = allowedChars.substring(0, dotIndex);
    if (allowedChars.length === 0 && dotIndex === 0) {
      allowedChars = '0';
    }
  }

  allowedChars = allowedChars.replace(/^0+/g, '0');

  if (allowedChars.length > 0) {
    const re = '\\d(?=(\\d{3})+$)';
    return `-$${allowedChars.replace(new RegExp(re, 'g'), '$&,')}${digits}`;
  }

  return '';
};

export const percent = (value, previousValue) => {
  const previousValueString = previousValue ? previousValue.toString() : '';
  let precentValue;
  if (previousValueString.replace('%', '') === value && previousValueString.substring(previousValueString.length - 1) === '%') {
    precentValue = value.toString().substring(0, previousValueString.length - 2);
  } else {
    precentValue = value.replace('%', '');
  }
  if (!precentValue) {
    return precentValue;
  }

  let onlyNumsDots = precentValue.replace(/[^0-9$.]/g, '');
  const dotIndex = onlyNumsDots.indexOf('.');
  const lastDotIndex = onlyNumsDots.lastIndexOf('.');
  if (dotIndex !== lastDotIndex) {
    onlyNumsDots = onlyNumsDots.substring(0, lastDotIndex)
      + onlyNumsDots.substring(lastDotIndex + 1);
  }

  onlyNumsDots = onlyNumsDots.substring(0, dotIndex + 3);

  if (onlyNumsDots.length > 0) {
    return `${onlyNumsDots}%`;
  }

  return '';
};

export const cardNumber = (value) => {
  if (!value) {
    return value;
  }
  const allowedChars = value.replace(/[\D]/g, '');
  if (allowedChars.length <= 4) {
    return allowedChars;
  }
  if (allowedChars.length <= 8) {
    return `${allowedChars.slice(0, 4)} ${allowedChars.slice(4)}`;
  }
  if (allowedChars.length <= 12) {
    return `${allowedChars.slice(0, 4)} ${allowedChars.slice(4, 8)} ${allowedChars.slice(8, 12)}`;
  }
  return `${allowedChars.slice(0, 4)} ${allowedChars.slice(4, 8)} ${allowedChars.slice(8, 12)} ${allowedChars.slice(12, 16)}`;
};

export const cardExpiration = (value) => {
  if (!value) {
    return value;
  }
  const allowedChars = value.replace(/[\D]/g, '');
  if (allowedChars.length <= 2) {
    return allowedChars;
  }
  return `${allowedChars.slice(0, 2)}/${allowedChars.slice(2, 4)}`;
};

export const cardCVV = (value) => {
  if (!value) {
    return value;
  }
  const allowedChars = value.replace(/[\D]/g, '');
  return allowedChars.slice(0, 4);
};

export const time = (value, prevValue, allValues, previousAllValues, name, defaultPeriod = 'am') => {
  if (!value) {
    return value;
  }
  const splitTime = value.replace(/[^\d:]/g, '').split(':');
  const splitTimeAndPeriod = value.split(' ');
  let allowedHours = splitTime[0].slice(0, 2);
  let allowedMinutes = splitTime[1] !== undefined
    ? splitTime[1].slice(0, 2)
    : null;
  let period = value.slice(-2).toLowerCase().replace(/[^amp]/g, '');
  if (!allowedMinutes && splitTime[0].length > 2) {
    allowedMinutes = splitTime[0].slice(2, 4);
  }
  if (value.length > 1 && splitTimeAndPeriod.length > 1) {
    period = splitTimeAndPeriod[1].toLowerCase().replace(/[^amp]/g, '');
    period = [...period].map((char, index, arr) => {
      switch (index) {
        case 0:
          if (arr[1]) {
            return char.replace(/[^ap]/g, '');
          }
          return char;
        case 1:
          return char.replace(/[^m]/g, '');
        default:
          return '';
      }
    }).join('');
  }

  allowedHours = [...allowedHours].map((char, index, arr) => {
    switch (index) {
      case 0:
        if (arr[1] && allowedMinutes && allowedMinutes.length > 0) {
          return char.replace(/[^01]/g, '');
        }
        return char;
      case 1:
        if (arr[0] === '1') {
          return char.replace(/[^012]/g, '');
        } else if (arr[0] === '0') {
          return char;
        }
        if (!allowedMinutes || allowedMinutes.length === 0) {
          allowedMinutes = char;
        }
        return '';
      default:
        return '';
    }
  }).join('');

  if (allowedMinutes) {
    allowedMinutes = [...allowedMinutes].map((char, index) => {
      switch (index) {
        case 0:
          return char.replace(/[^0-5]/g, '');
        case 1:
          return char;
        default:
          return '';
      }
    }).join('');
  }

  // Autofill Default Period
  if (!period
    && prevValue
    && prevValue.length < value.length
    && allowedMinutes
    && allowedMinutes.length === 2) {
    if (defaultPeriod === 'auto') {
      if ([8, 9, 10, 11].indexOf(Number(allowedHours)) !== -1) {
        period = 'am';
      } else {
        period = 'pm';
      }
    } else {
      period = defaultPeriod;
    }
  }

  if (allowedMinutes !== null) {
    if (period) {
      return `${allowedHours}:${allowedMinutes} ${period}`;
    }
    return `${allowedHours}:${allowedMinutes}`;
  }
  if (period) {
    return `${allowedHours} ${period}`;
  }
  return allowedHours;
};

export const timeDefaultPeriodPm = (value, prevValue, allValues, previousAllValues, name) =>
  time(value, prevValue, allValues, previousAllValues, name, 'pm');

export const timeDefaultPeriodAuto = (value, prevValue, allValues, previousAllValues, name) =>
  time(value, prevValue, allValues, previousAllValues, name, 'auto');

export const modifiers = (value) => {
  if (!value) {
    return value;
  }
  const allowedChars = value.toUpperCase();
  return allowedChars.slice(0, 2);
};

export const hcpcCode = (value) => {
  if (!value) {
    return value;
  }
  const prefix = value.slice(0, 1).toUpperCase().replace(/[^A-Z]/g, '');
  const code = value.slice(1).replace(/[^\d]/g, '');
  return `${prefix}${code}`;
};

export const uppercase = (value) => {
  if (!value) {
    return value;
  }
  return value.toUpperCase();
};

export const removeSpaces = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(' ', '');
};



// WEBPACK FOOTER //
// ./src/utils/normalize.js